import ShareCapital from "components/CompanyDashboard/MaintainYourCompany/Changes/ShareCapital/AllotmentOfShares/AllotmentTabs/ShareCapital";
import { useRef } from "react";

const Sharecapital = () => {
  const shareCapitalRef = useRef();
  const showAddCommentColumn = true;
  return (
    <div>
      {
        <ShareCapital
          ref={shareCapitalRef}
          showAddCommentColumn={showAddCommentColumn}
        />
      }
    </div>
  );
};

export default Sharecapital;
